import { render, staticRenderFns } from "./EntryForm.vue?vue&type=template&id=070c7c04&scoped=true&"
import script from "./EntryForm.vue?vue&type=script&lang=js&"
export * from "./EntryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c7c04",
  null
  
)

export default component.exports